import { proxy } from "valtio";

export const uiState = proxy({
	isLoading: true,
	homepage: {
		visible: false,
		showPage1: false,
		showPage2: false,
		isEnterHover: false,
		windowSize: { width: window.innerWidth, height: window.innerHeight },
		direction: "",
		prevMousePosition: { x: 0, y: 0 },
		isInitial: false,
		isLastAnimation: false,
		btnDisable: true,
	},
});

const getWindowSize = () => {
	const { innerWidth, innerHeight } = window;
	uiState.homepage.windowSize.width = innerWidth;
	uiState.homepage.windowSize.height = innerHeight;
};
window.addEventListener("resize", getWindowSize);

window.frontEnd = {
	...window.frontEnd,
	uiState,
};
